import { NewTag } from "@/components/Tag";
import { BREAKPOINTS } from "@/settings";
import { useMediaQuery } from "usehooks-ts";

export const SetHeaderTitle = ({
  title,
  isNew,
  hasRefreshed,
}: {
  title: string;
  isNew: boolean;
  hasRefreshed: boolean;
}) => {
  const isTouchDevice = useMediaQuery(BREAKPOINTS.TOUCH_DEVICE.query);
  return (
    <div className="pr-3 font-semibold text-white text-sm touch-device:text-xl flex flex-row items-center gap-x-2">
      {title}
      {(isNew || hasRefreshed) && isTouchDevice && (
        <NewTag type="new-design" tag={isNew ? "NEW" : "REFRESHED"} />
      )}
    </div>
  );
};
